import React from 'react';
import styles from './ContentDocsTransport.module.scss';
import { Empty, Icon, message, Upload } from 'antd';
import { maxFileSize } from '../../../../constants/maxFileSize';
import useAddAttachment from '../../api/mutation/useAddAttachment';
import DocList from '../DocList/DocList';
import { CardButton } from '../../../Card';

export const documentsAllowedExtensions = [
  'jpg',
  'pdf',
  'doc',
  'docx',
  'jpeg',
  'png',
  'raw',
  'tiff',
  'bmp',
];

const beforeUpload = (file) => {
  const fileExtension = file.name.split('.').pop().toLowerCase();

  if (!documentsAllowedExtensions.includes(fileExtension)) {
    message.error(`Файл ${file.name} имеет недопустимый формат.`);
    return false;
  }

  if (file.size > maxFileSize) {
    message.error(`Файл ${file.name} весит больше 15 мб.`);
    return false;
  }

  return true;
};

const ContentDocsTransport = ({ transportId, data = [] }) => {
  const { mutateAsync, isLoading } = useAddAttachment();

  const customRequest = async ({ file }) => {
    await mutateAsync({ transportId, file });
  };

  return (
    <div className={styles.root}>
      {!!data?.length ? (
        <DocList
          transportId={transportId}
          data={data}
        />
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Нет документов"
        />
      )}
      <Upload.Dragger
        className={styles.upload}
        multiple
        beforeUpload={beforeUpload}
        customRequest={customRequest}
        showUploadList={false}
      >
        {isLoading ? (
          <Icon type="loading" />
        ) : (
          <CardButton
            className={styles.btn}
            text="Добавить документ"
          />
        )}
      </Upload.Dragger>
    </div>
  );
};

export default ContentDocsTransport;
